<template>
  <!-- Modal -->
  <div class="modal fade" id="SingleOrdersModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{modalTitle}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="displayWarning" class="alert alert-danger">{{translations('order.check_date_shipping')}}</div>

          <div style="background: #f9f9f9;float:left;width:100%;margin-bottom:20px;">
            <div  style="float:left;width:25%">
              <table  class="table table-striped table-align-middle">
                <thead>
                  <tr style="background:#fff">
                    <th>{{translations('order.sale_date')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="d-flex">
                        <input v-model="shippingAt" type="date" class="form-control input-date" @blur='changeShippingAt()' @focus="tempDateField = shippingAt">
                        <input v-model="timeShippingAt" type="time" class="form-control input-time">
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div style="float:left;width:25%" >
              <table class="table table-striped table-align-middle">
                <thead>
                <tr style="background:#fff">
                  <th>{{translations('order.estimated_shipping_date')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <div class="d-flex">
                      <input v-model="shippingScheduleAt" type="date" class="form-control input-date" @blur='changeShippingScheduleAt()' @focus="tempDateScheduleField = shippingScheduleAt">
                      <input v-model="timeShippingScheduleAt" type="time" class="form-control input-time">
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div style="float:left;width:25%">
              <table class="table table-striped table-align-middle">
                <thead>
                <tr style="background:#fff;">
                  <th>{{translations('order.shipping_warehouse')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <div class="dropdown">
                      <button :disabled="ordersInfo.division_type === 'B' ? true : false" id='filterByClient' class="btn btn-outline-secondary dropdown-toggle" type="button" :data-toggle="ordersInfo.division_type !== 'B' ? 'dropdown' : ''" aria-haspopup="true" aria-expanded="false">
                        {{ selectWarehouse ? selectWarehouse.name : translations('order.warehouse_selection') }}
                      </button>
                      <div class="dropdown-menu">
                        <a class='dropdown-item' v-on:click='warehouseId=0'>{{ translations('order.warehouse_selection') }}</a>
                        <a class='dropdown-item' v-for='(item, i) in warehouses' :style="item.id === disableWareHouse ? 'color:red;background:#ddd' : ''"  :key='i' v-on:click='item.id === disableWareHouse ? null :warehouseId=item.id'>
                          {{ item.name }}
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div style="float:left;width:25%;">
              <table class="table table-striped table-align-middle">
                <thead>
                <tr style="background:#fff; height: 46px">
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <button class="btn btn-primary btn-sm" type="button" style="width: 80px; height: 34px" @click="submitSearch">{{translations('common.search')}}</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div table-scroll>
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>{{translations('order.order_date')}}</th>
                  <th>{{translations('order.order_number')}}</th>
                  <th>{{translations('order.bill_to')}}</th>
                  <th>{{translations('order.destination_name')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="ordersInfo.division_type !== 'B'">
                  <td>
                    {{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '-----------' }}
                  </td>
                  <td>{{ ordersInfo.order_number }}</td>
                  <td >
                    {{ ordersInfo.client && ordersInfo.client.name ? ordersInfo.client.name : '-----------' }}
                  </td>
                  <td>
                    {{ ordersInfo.destination_name ? ordersInfo.destination_name : '--------------' }}
                  </td>
                </tr>

                <tr v-else>
                  <td>
                    {{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '-----------' }}
                  </td>
                  <td>{{ ordersInfo.order_number }}</td>
                  <td >
                    {{ ordersInfo.warehouse_address_from }}
                  </td>
                  <td>
                    {{ ordersInfo.warehouse_address }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{translations('order.line_number')}}</th>
                <th>{{translations('order.jan_code')}}</th>
                <th>{{translations('order.model')}}</th>
                <th>{{translations('order.number_orders_received')}}</th>
                <th>{{translations('order.unit_price')}}</th>
                <th>{{translations('order.product_cost_new')}}</th>
                <th>{{translations('order.client_order_number')}}</th>
                <th>{{translations('order.division')}}</th>
                <th>{{translations('order.inventory')}}</th>
                <th>{{translations('order.remaining_number_notes')}}</th>
                <th>{{translations('order.all_outstanding_orders')}}</th>
                <th>{{translations('order.number_shipments')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(product, i) in warehouseProducts">
              <tr :key="i">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{product.jan_code}}</td>
                <td>{{product.type_number}}</td>
                <td class="right">{{product.quantity.toLocaleString()}}</td>
                <td class="right">{{product.display_price.toLocaleString()}}</td>
                <td class="right">{{product.row_price.toLocaleString()}}</td>
                <td>{{product.client_order_number}}</td>
                <td>{{(product.defective || Number(product.is_bad)) ? translations('order.bad') : Number(product.is_outlet) ? translations('order.outlet') : translations('order.good')}}</td>
                <td class="right">{{product.stock_quantity.toLocaleString()}}</td>
                <td class="right">{{product.remain_quantity.toLocaleString()}}</td>
                <td class="right">{{product.total_remaining}}</td>
                <td v-if="product.stock_quantity>0">
                  <input v-on:keyup="shippingQuantityKeyUp($event,product)" v-model="product.shippingQuantity" :class="classShippingQuantity" type="text" placeholder="0" min-value="0" :disabled="product.remain_quantity===0">
                </td>
                <td v-else class="text-danger">{{translations('order.not_in_stock')}}</td>
              </tr>
              </template>
            </tbody>
          </table>
          </div>

        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button v-if="ordersInfo.division_type !== 'B'" type="button" class="btn btn-primary" @click="addShipping">{{translations('common.update')}}</button>
          <button v-else type="button" class="btn btn-primary" @click="addMoviing">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { format } from 'date-fns'
import { saveAs } from 'file-saver'
import { mapState } from 'vuex'
import { YahooCsvFields, YahooItemFields, YamadaCsvFields, YamadaItemFields } from '@/constants'

const Papa = require('papaparse')
const encoding = require('encoding-japanese')

export default {
  name: 'SingleOrdersModal',
  components: {
    VueElementLoading
  },
  props: {
    buttonType: null,
    orderID: Number,
    ordersInfo: Object,
    warehouseRedFlag: Array
  },
  data () {
    return {
      shippingAt: '',
      timeShippingAt: '',
      shippingScheduleAt: '',
      timeShippingScheduleAt: '',
      displayWarning: false,
      isSearching: false,
      warehouseProducts: [],
      tempDateField: '',
      tempDateScheduleField: '',
      warehouseId: 0,
      warehouseName: '',
      classShippingQuantity: ''
    }
  },
  created () {
    this.shippingAt = format(new Date(), 'yyyy-MM-dd')
    this.timeShippingAt = format(new Date(), 'HH:mm')
    this.shippingScheduleAt = this.shippingAt
    this.timeShippingScheduleAt = this.timeShippingAt
  },
  mounted () {
    const self = this
    window.$('#SingleOrdersModal').on('shown.bs.modal', function () {
      self.$store.dispatch('Master/checkMywarehouses').then(() => {
        if (self.ordersInfo.division_type && self.ordersInfo.division_type === 'B') {
          self.warehouseId = Number(self.ordersInfo.warehouse_id_from.id)
        } else {
          self.warehouseId = 57 // デシターをデフォルトに
        }
      })
      window.$('#SingleOrdersModal').find('.table-scroll').css('height', (window.innerHeight - 400) + 'px')
    })
  },
  watch: {
    shippingAt: {
      handler: function (data, oldData) {
        if (Number(data.substr(8, 2)) >= 25) {
          this.displayWarning = true
        } else {
          this.displayWarning = false
        }
      }
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    modalTitle () {
      if (this.buttonType === 1) {
        return this.ordersInfo.division_type === 'B' ? this.translations('order.move_processing') : this.translations('order.shipping_processing')
      } else if (this.buttonType === 2) {
        return this.translations('order.delivery_processing')
      } else {
        return ''
      }
    },
    warehouses () {
      if (this.ordersInfo.division_type && this.ordersInfo.division_type === 'B') {
        return this.$props.warehouseRedFlag
      }
      return this.$store.getters['Master/getMywarehouses']
    },
    selectWarehouse () {
      if (this.warehouses) {
        return this.warehouses.find(warehouse => warehouse.id === this.warehouseId)
      }
    },
    disableWareHouse () {
      if (this.ordersInfo.division_type && this.ordersInfo.division_type === 'B') {
        return this.ordersInfo.warehouse_id.id
      }
      return null
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },

    showWarning () {
      let date = new Date().getDate()

      this.displayWarning = (date >= 25)
    },

    shippingQuantityKeyUp (event, product) {
      let { value } = event.target
      value = value.replace(/\D/g, '')
      if (value && value <= 0) value = 1
      event.target.value = value
      product.shippingQuantity = Number(value)
      if (product.reserve_quantity && product.shippingQuantity > product.reserve_quantity) {
        this.classShippingQuantity = 'form-control form-control-sm text-danger'
        product.check_quantity_ship = true
      } else {
        this.classShippingQuantity = 'form-control form-control-sm'
        product.check_quantity_ship = false
      }
    },

    changeShippingAt () {
      if (this.tempDateField === this.shippingAt) return
      if (!this.shippingAt) {
        this.shippingAt = new Date().toISOString().slice(0, 10)
      }
      if (!this.tempDateField) {
        this.tempDateField = this.shippingAt
      }

      this.shippingScheduleAt = this.shippingAt
      this.changeShippingScheduleAt()
    },

    changeShippingScheduleAt () {
      if (this.tempDateScheduleField === this.shippingScheduleAt) return
      if (!this.shippingScheduleAt) {
        this.shippingScheduleAt = new Date().toISOString().slice(0, 10)
      }
      if (!this.tempDateScheduleField) {
        this.tempDateScheduleField = this.shippingScheduleAt
      }
    },

    async listWarehouseProducts () {
      this.isSearching = true
      const params = {
        orders_id: this.orderID,
        shipped_at: this.shippingScheduleAt,
        warehouse_id: this.warehouseId,
        reserve: false
      }
      try {
        const { data } = await this.$http.post(this.$api_url.orders_warehouse_products, params)
        if (data.status) {
          this.warehouseProducts = data.item_list
          this.warehouseProducts.forEach(item => {
            if (item.tax_included) {
              item.display_price = item.unit_price_inctax
            } else {
              item.display_price = item.unit_price
            }

            if (!item.defective && item.stock_quantity > 0) {
              item.shippingQuantity = item.remain_quantity
            } else {
              item.shippingQuantity = 0
            }

            if (item.is_intangible_assets === 1) {
              item.stock_quantity = 1
              if (item.remain_quantity > 0) {
                item.shippingQuantity = 1
              }
            }
            if (item.check_quantity_ship) {
              this.classShippingQuantity = 'form-control form-control-sm text-danger'
            } else {
              this.classShippingQuantity = 'form-control form-control-sm'
            }
          })
        } else {
          this.$toastr.error(data.message, this.translations('common.error'))
        }
        await this.getQuantityRemaining()
      } catch (error) {
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
      this.isSearching = false
    },

    async addMoviing () {
      if (this.shippingAt === '') {
        this.$toastr.warning(this.translations('order.notice_enter_sale_date'))
        return
      }
      if (this.shippingScheduleAt === '') {
        this.shippingScheduleAt = this.shippingAt
      }
      let referenceAt = format(new Date(`${this.shippingScheduleAt} ${this.timeShippingScheduleAt}`), "yyyy-MM-dd'T'HH:mm:59")
      let paramsToMoveProduct = []
      for (let index = 0; index < this.warehouseProducts.length; index++) {
        const eachProduct = this.warehouseProducts[index]
        if (Number(eachProduct.shippingQuantity) > 0) {
          if (Number(eachProduct.shippingQuantity) > Number(eachProduct.stock_quantity)) { // 出荷数 > 在庫数
            this.$toastr.warning(this.translations('order.notice_valid_quantity_shipping_stock'))
            return // CONTINUE
          }
          // Get status Condition Stock
          let statusProductInStock = 0
          if (eachProduct.is_bad === '1') {
            statusProductInStock = 1
          } else if (eachProduct.is_outlet === '1') {
            statusProductInStock = 2
          } else {
            statusProductInStock = 0
          }

          let params = {
            product_id: eachProduct.product_id,
            detail_id: eachProduct.detail_id,
            reference_at: referenceAt,
            warehouses_id_from: this.warehouseId,
            warehouses_id_to: this.ordersInfo['warehouse_id']['id'],
            in_stock_status: statusProductInStock,
            condition: statusProductInStock,
            amount: eachProduct.shippingQuantity,
            stock_id: eachProduct.stock_id
          }
          paramsToMoveProduct.push(params)
        }
      }
      if (!paramsToMoveProduct.length) {
        this.isSearching = false
        this.$toastr.warning(this.translations('order.notice_valid_quantity_shipping_stock'))
        return
      }
      let formData = {
        orders_id: this.orderID,
        paramsToMoveProduct: paramsToMoveProduct,
        shipping_at: format(new Date(`${this.shippingAt} ${this.timeShippingAt}`), "yyyy-MM-dd'T'HH:mm:ss"),
        shipping_schedule_at: format(new Date(`${this.shippingScheduleAt} ${this.timeShippingScheduleAt}`), "yyyy-MM-dd'T'HH:mm:ss")
      }

      let response = await this.$http.post(this.$api_url.move_to_shipped, formData)

      if (response.data.status === true) {
        this.$toastr.success(this.translations('order.notice_shipping_process_completed'), this.translations('common.success'))
        this.$refs.closeModal.click()
        location.reload()
      } else {
        this.$toastr.error(response.data.message, this.translations('common.error'))
      }

      this.isSearching = false
    },
    async addShipping () {
      if (this.shippingAt === '') {
        this.$toastr.warning(this.translations('order.notice_enter_sale_date'))
        return
      }
      if (this.shippingScheduleAt === '') {
        this.shippingScheduleAt = this.shippingAt
      }

      try {
        let quantityError = false
        let shippedError = false
        let checkQuantityShipError = false
        // let checkQuantityOldShipError = false
        let isNullDataOnWarehouse = false
        let checkNumberShippingQuantity = false
        let productList = []
        let self = this
        this.warehouseProducts.forEach(function (product) {
          if (!Number.isInteger(Number(product.shippingQuantity))) {
            checkNumberShippingQuantity = true
            return
          }
          if (Number(product.shippingQuantity) > 0) {
            if (Number(product.shippingQuantity) > Number(product.stock_quantity)) { // 出荷数 > 在庫数
              quantityError = true
              return // CONTINUE
            }
            if (Number(product.shippingQuantity) > Number(product.remain_quantity)) { // 出荷数 > 注残数
              shippedError = true
              return // CONTINUE
            }
            if (product.check_quantity_ship) {
              checkQuantityShipError = true
            }
            // if (product.check_quantity_old_ship) {
            //   checkQuantityOldShipError = true
            // }

            productList.push({
              detail_id: product.detail_id,
              warehouse_id: self.warehouseId,
              defective: product.defective,
              product_id: product.product_id,
              jan_code: product.jan_code,
              type_number: product.type_number,
              unit_price: product.unit_price,
              unit_price_inctax: self.$util.getIncludeTax(product.unit_price, product.tax_rate),
              client_order_number: product.client_order_number,
              quantity: Number(product.shippingQuantity),
              younosuke_company_id: self.$parent.tempInfo.client_id,
              is_outlet: product.is_outlet,
              is_bad: product.is_bad,
              row_price: product.row_price
            })
          }

          if (Number(product.stock_quantity) <= 0) {
            isNullDataOnWarehouse = true
          }
        })
        if (checkNumberShippingQuantity) {
          this.isSearching = false
          this.$toastr.warning(this.translations('order.notice_valid_quantity_integer'))
          return
        }
        if (quantityError) {
          this.isSearching = false
          this.$toastr.warning(this.translations('order.notice_valid_quantity_shipping_stock'))
          return
        }
        if (shippedError) {
          this.isSearching = false
          this.$toastr.warning(this.translations('order.notice_valid_quantity_shipping_remaining'))
          return
        }
        if (!productList.length && isNullDataOnWarehouse) {
          this.isSearching = false
          this.$toastr.warning(this.translations('order.notice_product_out_of_stock'))
          return
        }
        if (!productList.length) {
          this.isSearching = false
          this.$toastr.warning(this.translations('order.notice_valid_quantity_shipping_stock'))
          return
        }

        // const today = new Date()
        // const formattedDate = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0')
        // if (this.shippingAt > formattedDate) {
        //   this.isSearching = false
        //   this.$toastr.warning(this.translations('order.notice_shipping_future_date'))
        //   return
        // }

        let params = {
          orders_id: this.orderID,
          shipping_at: format(new Date(`${this.shippingAt} ${this.timeShippingAt}`), "yyyy-MM-dd'T'HH:mm:ss"),
          shipping_schedule_at: format(new Date(`${this.shippingScheduleAt} ${this.timeShippingScheduleAt}`), "yyyy-MM-dd'T'HH:mm:ss"),
          product_list: productList,
          outsourcing_type: this.buttonType, // 0:未登録, 1:通常販売, 2:委託販売
          check_order_reserve: this.ordersInfo.check_order_reserve
        }

        if (checkQuantityShipError) {
          this.$dialog.confirm(this.translations('order.notice_shipping_with_reserve'), {
            okText: this.translations('common.yes'),
            cancelText: this.translations('common.no'),
            persistent: true
          }).then(async () => {
            if (this.ordersInfo.check_order_reserve) {
              this.$dialog.confirm(this.translations('order.notice_ship_when_reserve'), {
                okText: this.translations('common.yes'),
                cancelText: this.translations('common.no')
              }).then(async () => {
                await this.callApiShipping(params)
                this.isSearching = false
              })
            } else {
              await this.callApiShipping(params)
              this.isSearching = false
            }
            this.isSearching = false
          })
        } else {
          this.isSearching = true

          if (this.ordersInfo.check_order_reserve) {
            this.$dialog.confirm(this.translations('order.notice_ship_when_reserve'), {
              okText: this.translations('common.yes'),
              cancelText: this.translations('common.no')
            }).then(async () => {
              await this.callApiShipping(params)
              this.isSearching = false
            })
          } else {
            await this.callApiShipping(params)
            this.isSearching = false
          }
          this.isSearching = false
        }
      } catch (error) {
        console.log('SingleOrders:updateOrders:catch(error): ', error)
        this.$toastr.error(this.translations('order.notice_shipping_process_failed'), this.translations('common.error'))
        this.isSearching = false
      }
    },

    async callApiShipping (params) {
      this.isSearching = true
      let response = await this.$http.post(this.$api_url.add_to_shipped, params)

      console.log('SingleOrdersModal:response', response)

      if (response !== undefined && response.data.status === true) {
        this.$toastr.success(this.translations('order.notice_shipping_process_completed'), this.translations('common.success'))
        this.$parent.ordersInfo.order_status = response.data.order_status // 1:未出荷, 2:出荷済み, [3:一部出荷]
        this.$parent.ordersInfo.outsourcing_type = response.data.outsourcing_type
        if (response.data.result_csv) {
          this.saveCsv_(response.data.result_csv, response.data.result_type)
        }
        this.tempDateField = ''
        this.isSearching = false
        this.$refs.closeModal.click()
        setTimeout(() => {
          location.reload()
        }, 500)
      } else {
        this.isSearching = false
        // this.translations('reserve.' + updateOrder.data.message)
        this.$toastr.warning(this.translations('order.' + response.data.message))
      }
      this.isSearching = false
    },

    saveCsv_ (list, type) {
      const data = []

      list.forEach(item => {
        if (type === ('yamada')) {
          data.push(YamadaItemFields.map(field => item[field]))
        }
        if (type === ('yahoo')) {
          data.push(YahooItemFields.map(field => item[field]))
        }
      })
      let csv = ''
      if (type === ('yamada')) {
        csv = Papa.unparse({
          fields: YamadaCsvFields,
          data: data
        })
      }
      if (type === ('yahoo')) {
        csv = Papa.unparse({
          fields: YahooCsvFields,
          data: data
        })
      }

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv;charset=windows-1252' })
      const d = new Date()
      const filename = (type === ('yamada') ? 'OUTPUT ASN_' : 'OUTPUT YAHOO_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '.csv'

      saveAs(content, filename)

      this.isLoading = false
    },

    async getQuantityRemaining () {
      try {
        const { data: { data, status } } = await this.$http.post(this.$api_url.orders_quantity_remaining, { order_id: this.orderID })
        if (status) {
          this.warehouseProducts.forEach((product) => {
            const findProduct = data.find((quantity) => quantity.product_id === product.product_id)
            if (findProduct) {
              this.$set(product, 'total_remaining', findProduct.total_remaining)
            }
          })
        }
      } catch (error) {}
    },

    submitSearch () {
      this.listWarehouseProducts()
    }
  }
}
</script>

<style scoped>
.input-date {
  width: 160px;
}
</style>
